<div #blockBody class="external-golf-tournament" class="{{ displayMode }}">
	<div class="match-page-loading" *ngIf="tournamentLoading && !tournamentError">
		<span>
			Loading tournament data<span class="animated-ellipsis"><span class="dot dot1">.</span><span class="dot dot2">.</span><span class="dot dot3">.</span></span>
		</span>
	</div>
	<div class="match-page-loading" *ngIf="tournamentError">
		<span class="error-main">
			<span>
				We are having trouble loading tournament data
			</span>
		</span>

		<span>
			Please
			<span class="retry-link"
				(click)="reloadTournamentData(configurationObject.season, configurationObject.tournamentID)">
				try again
			</span>
		</span>
	</div>
	<div class="tournament-header" *ngIf="!tournamentLoading && !tournamentError">
		<div class="top-row">
			<div class="sport-name-ctr" *ngIf="!tournamentLoading && !tournamentError">
				<app-sport-icon class="ball-icon"
					[code]="'GOLF'"
					colour="black"
				></app-sport-icon>
				<div class="sport-name">
					{{ tournamentData.tour }}
				</div>
			</div>
		</div>
		<div class="main-row">
			<div class="tournament-info-ctr">
				<div class="tournament-name">{{ tournamentData.tournamentName }}</div>
				<div class="tournament-dates">{{ tournamentDateString() }}</div>
				<div class="tournament-host">
					{{ tournamentData.courseName }}
					-
					{{ tournamentData.city }},
					{{ tournamentData.country === 'USA' ?
						tournamentData.state : tournamentData.country }}
				</div>
				<div class="tournament-stats">
					<span class="tournament-stat" *ngIf="tournamentData.tournamentPrize">
						<span class="stat-title">Purse</span>&nbsp;
						<span class="stat-value">{{ tournamentData.tournamentPrize }}</span>
					</span>
					<span class="tournament-stat">
						<span class="stat-title">Par</span>&nbsp;
						<span class="stat-value">{{ tournamentData.coursePar }}</span>
					</span>
					<span class="tournament-stat">
						<span class="stat-title">Yards</span>&nbsp;
						<span class="stat-value">{{ tournamentData.courseDistance | number: '1.0-0' }}</span>
					</span>
				</div>
			</div>
			<div class="weather-ctr">
				<div class="weather-day-ctr" *ngIf="tournamentData.WeatherInfo">
					<div class="weather-day" *ngFor="let day of tournamentData.WeatherInfo; index as index">
						<div class="day-title">Day {{ index + 1 }}</div>
						<div class="day-icon">
							<img class="weather-icon"
								[src]="day.newIcon"
								[alt]="day.description">
						</div>
						<div class="day-temps">
							<span *ngIf="configurationObject.temperatureDisplay === 'fahrenheit'">
								{{ day.temperatureLow | toFahrenheit | number: '1.0-0' }}-{{ day.temperatureHigh | toFahrenheit | number: '1.0-0' }}°F
							</span>
							<span *ngIf="configurationObject.temperatureDisplay !== 'fahrenheit'">
								{{ day.temperatureLow | number: '1.0-0' }}-{{ day.temperatureHigh | number: '1.0-0' }}°C
							</span>
						</div>
					</div>
				</div>
				<div class="weather-attr" *ngIf="tournamentData.WeatherInfo">
					<a target="_blank" href="https://darksky.net/poweredby/" rel="noreferrer">
						Weather powered by Dark Sky
						<img class="lighter" src="https://content-blocks-node.azurewebsites.net/static/assets/dark-sky-weather-logo.png" alt="">
					</a>
				</div>
			</div>
		</div>
	</div>

	<div class="match-page-tabs" *ngIf="!tournamentLoading && !tournamentError">
		<div class="match-page-tab-selector">
			<div class="tab-option" [class.selected-option]="tournamentActiveTab === 'futures'" (click)="setTournamentActiveTab('futures')">
				<span class="large-only">Tournament Futures</span>
				<span class="compact-only">Futures</span>
			</div>
			<div class="tab-option" *ngIf="tournamentData.H2HData" [class.selected-option]="tournamentActiveTab === 'h2h'" (click)="setTournamentActiveTab('h2h')">
				<span class="large-only">Tournament H2H</span>
				<span class="compact-only">H2H</span>
			</div>
			<div class="tab-option" *ngIf="tournamentData.ThreeBall" [class.selected-option]="tournamentActiveTab === 'three-ball'" (click)="setTournamentActiveTab('three-ball')">
				<span class="large-only">3 Ball Matchup</span>
				<span class="compact-only">3 Ball</span>
			</div>
		</div>


		<div class="match-page-tab futures" *ngIf="tournamentActiveTab === 'futures'">
			<div class="options-row">

				<!-- title - will reflect selection in toggles -->
				<div class="tab-heading">
					<span class="compact-only">
						Tournament Predictions
					</span>
					<span class="large-only" *ngIf="golfFuturesMarket === 'winner'">
						Tournament Predictions: Winner
					</span>
					<span class="large-only" *ngIf="golfFuturesMarket === 'top20'">
						Tournament Predictions: Top 20
					</span>
					<span class="large-only" *ngIf="golfFuturesMarket === 'top10'">
						Tournament Predictions: Top 10
					</span>
					<span class="large-only" *ngIf="golfFuturesMarket === 'top5'">
						Tournament Predictions: Top 5
					</span>
					<span class="last-updated">
						Last Updated:
						<span class="lu-time">{{ futuresLastUpdated }}</span>
					</span>
				</div>
				<!-- toggles - Make cut / Top 20 / Winner -->
				<div class="block-toggles large-only">
					<div class="block-toggle"
						[class.selected-option]="golfFuturesMarket === 'top20'"
						(click)="setGolfFuturesMarket('top20')">
						Top 20
					</div>
					<div class="block-toggle"
						[class.selected-option]="golfFuturesMarket === 'top10'"
						(click)="setGolfFuturesMarket('top10')">
						Top 10
					</div>
					<div class="block-toggle"
						[class.selected-option]="golfFuturesMarket === 'top5'"
						(click)="setGolfFuturesMarket('top5')">
						Top 5
					</div>
					<div class="block-toggle"
						[class.selected-option]="golfFuturesMarket === 'winner'"
						(click)="setGolfFuturesMarket('winner')">
						Winner
					</div>
				</div>
			</div>
			<div class="title-row">
				<!-- Round/Pre-tourn filter -->
				<div class="dropdowns">
					<div class="dropdown stage-dropdown">
						<div class="dropdown-button" (click)="toggleStageDropdown()">
							<div class="current-option">
								<span *ngIf="golfFuturesStage === 'pre'">Pre-Tournament</span>
								<span *ngIf="golfFuturesStage === 'after1'">After Round 1</span>
								<span *ngIf="golfFuturesStage === 'after2'">After Round 2</span>
								<span *ngIf="golfFuturesStage === 'after3'">After Round 3</span>
							</div>

							<div class="dropdown-caret">
								<span *ngIf="stageDropdownOpen"><fa-icon [icon]="faChevronUp"></fa-icon></span>
								<span *ngIf="!stageDropdownOpen"><fa-icon [icon]="faChevronDown"></fa-icon></span>
							</div>
						</div>
						<div class="dropdown-options height-cap" *ngIf="stageDropdownOpen">
							<div class="single-option-list">
								<div class="dropdown-option"
									[class.selected-option]="golfFuturesStage === 'pre'"
									(click)="setGolfFuturesStage('pre')">
									<div class="option-name">
										<span>Pre-Tournament</span>
									</div>
									<div class="option-tick" *ngIf="golfFuturesStage === 'pre'">
										<fa-icon [icon]="faCheck"></fa-icon>
									</div>
								</div>
								<div class="dropdown-option"
									*ngIf="roundDataAvailable(1)"
									[class.selected-option]="golfFuturesStage === 'after1'"
									(click)="setGolfFuturesStage('after1')">
									<div class="option-name">
										<span>After Round 1</span>
									</div>
									<div class="option-tick" *ngIf="golfFuturesStage === 'after1'">
										<fa-icon [icon]="faCheck"></fa-icon>
									</div>
								</div>
								<div class="dropdown-option"
									*ngIf="roundDataAvailable(2)"
									[class.selected-option]="golfFuturesStage === 'after2'"
									(click)="setGolfFuturesStage('after2')">
									<div class="option-name">
										<span>After Round 2</span>
									</div>
									<div class="option-tick" *ngIf="golfFuturesStage === 'after2'">
										<fa-icon [icon]="faCheck"></fa-icon>
									</div>
								</div>
								<div class="dropdown-option"
									*ngIf="roundDataAvailable(3)"
									[class.selected-option]="golfFuturesStage === 'after3'"
									(click)="setGolfFuturesStage('after3')">
									<div class="option-name">
										<span>After Round 3</span>
									</div>
									<div class="option-tick" *ngIf="golfFuturesStage === 'after3'">
										<fa-icon [icon]="faCheck"></fa-icon>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- Player Search Bar -->
					<div class="player-search">
						<input type="text" [(ngModel)]="playerSearch" placeholder="Search for players..."
							(keyup)="setAllPlayerLists()" />
						<div class="search-clear-button" (click)="clearPlayerSearch()" [class.hidden-button]="playerSearch === ''">
							<fa-icon [icon]="faTimesCircle" aria-label="Clear Search Query" role="button"></fa-icon>
						</div>
						<div class="search-icon-ctr">
							<fa-icon [icon]="faSearch" class="search-icon" aria-hidden="true"></fa-icon>
						</div>
					</div>
				</div>

				<!-- bookie key -->
				<!-- Bookie Key -->
				<div class="bookie-key-ctr"
					*ngIf="!(environment.sportExclusiveBookmakers && environment.sportExclusiveBookmakers['GOLF'])"
				>
					<div class="bookie-key single-row compact-only">
						<div class="key-ctr">
							<div class="key-listing">
								<div class="bookie-icon value-icon"></div>
								<div class="bookie-name">Value Identified</div>
							</div>
						</div>
					</div>

					<div class="bookie-key">
						<!-- <div class="key-title">Key</div> -->
						<div class="key-ctr">
							<div class="key-listing" *ngFor="let option of bookOptions" [class]="option">
								<img loading="lazy"
									class="bookie-icon"
									[src]="option | bookIcon"
									alt=""
								>
								<div class="bookie-name">{{ betService.stylisedBookName(option) }}</div>
							</div>
						</div>
	
					</div>
				</div>

				<div class="bookie-ident"
					*ngIf="environment.sportExclusiveBookmakers && environment.sportExclusiveBookmakers['GOLF'] && !['tab', 'default'].includes(environment.sportExclusiveBookmakers['GOLF'])"
					[class]="environment.sportExclusiveBookmakers && environment.sportExclusiveBookmakers['GOLF']
						? environment.sportExclusiveBookmakers['GOLF'] : ''"
				>
					<div class="powered-by">
						Odds powered by
					</div>
					<img loading="lazy"
						class="bookie-logo"
						[src]="environment.sportExclusiveBookmakers['GOLF'] | bookLogo"
						[alt]="betService.stylisedBookName(environment.sportExclusiveBookmakers['GOLF'])"
					>
				</div>
			</div>
			<div class="options-row compact-only">
				<!-- toggles - Top 10 / Top 20 / Winner -->
				<div class="block-toggles">
					<div class="block-toggle"
						[class.selected-option]="golfFuturesMarket === 'top20'"
						(click)="setGolfFuturesMarket('top20')">
						Top 20
					</div>
					<div class="block-toggle"
						[class.selected-option]="golfFuturesMarket === 'top10'"
						(click)="setGolfFuturesMarket('top10')">
						Top 10
					</div>
					<div class="block-toggle"
						[class.selected-option]="golfFuturesMarket === 'top5'"
						(click)="setGolfFuturesMarket('top5')">
						Top 5
					</div>
					<div class="block-toggle"
						[class.selected-option]="golfFuturesMarket === 'winner'"
						(click)="setGolfFuturesMarket('winner')">
						Winner
					</div>
				</div>

				<!-- title - will reflect selection in toggles -->
				<div class="tab-heading">
					<span *ngIf="golfFuturesMarket === 'winner'">
						Winner
					</span>
					<span *ngIf="golfFuturesMarket === 'top20'">
						Top 20
					</span>
					<span *ngIf="golfFuturesMarket === 'top10'">
						Top 10
					</span>
					<span *ngIf="golfFuturesMarket === 'top5'">
						Top 5
					</span>
				</div>
			</div>
			<div class="futures-list-ctr">
				<div class="player-list">
					<div class="header-row">
						<div class="header-shell">
							<div class="header-cell pos-col">
								Pos
							</div>
							<div class="header-cell player-col">
								Player
							</div>
							<div class="header-cell score-col sortable highlighted" *ngIf="golfFuturesStage !== 'pre'" (click)="setFuturesPlayerSort('position')">
								<span>
									Total 
									<ng-container *ngIf="futuresPlayerSortVariable !== 'position'"><fa-icon [icon]="faSort" class="lighter"></fa-icon></ng-container>
									<ng-container *ngIf="futuresPlayerSortVariable === 'position' && futuresPlayerSortReversed"><fa-icon [icon]="faSortUp"></fa-icon></ng-container>
									<ng-container *ngIf="futuresPlayerSortVariable === 'position' && !futuresPlayerSortReversed"><fa-icon [icon]="faSortDown"></fa-icon></ng-container>
								</span>
							</div>
							<div class="header-cell score-col" *ngIf="golfFuturesStage !== 'pre'">
								<span class="large-only" *ngIf="golfFuturesStage === 'after1'">Round 1</span>
								<span class="large-only" *ngIf="golfFuturesStage === 'after2'">Round 2</span>
								<span class="large-only" *ngIf="golfFuturesStage === 'after3'">Round 3</span>
								<span class="compact-only" *ngIf="golfFuturesStage === 'after1'">R1</span>
								<span class="compact-only" *ngIf="golfFuturesStage === 'after2'">R2</span>
								<span class="compact-only" *ngIf="golfFuturesStage === 'after3'">R3</span>
							</div>
							<div class="header-cell prob-col sortable" (click)="setFuturesPlayerSort('probability')">
								<span>
									{{ displayMode.includes('compact') ? 'Prob.' : 'Probability' }}
									 
									<ng-container *ngIf="futuresPlayerSortVariable !== 'probability'"><fa-icon [icon]="faSort" class="lighter"></fa-icon></ng-container>
									<ng-container *ngIf="futuresPlayerSortVariable === 'probability' && futuresPlayerSortReversed"><fa-icon [icon]="faSortUp"></fa-icon></ng-container>
									<ng-container *ngIf="futuresPlayerSortVariable === 'probability' && !futuresPlayerSortReversed"><fa-icon [icon]="faSortDown"></fa-icon></ng-container>
								</span>
							</div>
							<div class="header-cell odds-col">
								{{ (environment.sportExclusiveBookmakers && environment.sportExclusiveBookmakers['GOLF']) ? 'Odds' : 'Best Odds' }}
							</div>
							<div class="header-cell value-col">
								<div class="value-indi">
									<div class="value-icon" aria-label="Value Identified" role="note"></div>
									<div class="value-info-popup">
										<div class="arrow-point"></div>
										<span>Value Identified</span>
									</div>
								</div>
							</div>
							<div class="header-cell bet-col"
								*ngIf="environment.sportExclusiveBookmakers?.['GOLF'] !== 'tab'"
							>
							</div>
						</div>

					</div>
					<div class="player-row" *ngFor="let player of displayedFuturesPlayers">
						<div class="scroll-shell">

							<div class="scroll-section">
								<!-- Position column -->
								<div class="scroll-cell pos-col">
									{{ playerPosition(player) }}
								</div>
								<div class="scroll-cell player-col">
									<div class="icon-name-ctr">
										<app-flag-icon class="team-logo flag"
											[countryCode]="countryLookup[(player.playerCountry | uppercase) || ''] || ''"
										></app-flag-icon>
										<span>
											{{ player.playerFirstName }}
											{{ player.playerLastName }}
										</span>
									</div>
								</div>
								<!-- Total column (if not Pre-Tournament) -->
								<div class="scroll-cell score-col highlighted" *ngIf="golfFuturesStage !== 'pre'">
									{{ playerScore(player, golfFuturesStage) }}
								</div>
								<!-- Round x column (if not Pre-Tournament) -->
								<div class="scroll-cell score-col" *ngIf="golfFuturesStage !== 'pre'">
									{{ playerRoundScore(player, golfFuturesStage) }}
								</div>
								<!-- Probability column (prob. of selected market) -->
								<div class="scroll-cell prob-col">
									<div class="prob-ctr">
										<span class="prob">{{ probDisplay(player, golfFuturesMarket) }}</span>
										<span class="change" *ngIf="golfFuturesStage !== 'pre'"
											[class]="probChangeColour(player, golfFuturesMarket)">
											{{ probChange(player, golfFuturesMarket) }}
										</span>
									</div>
								</div>
								<!-- Best Odds column (odds of selected market) -->
								<div class="scroll-cell odds-col">
									<span>{{ formattedBestFuturesOdds(player, golfFuturesMarket) }}</span>
								</div>
								<div class="scroll-cell value-col">
									<div class="value-indi" *ngIf="futuresValueOpacity(player, golfFuturesMarket) > 0"
										[style.opacity]="futuresValueOpacity(player, golfFuturesMarket)">
										<div class="value-icon" aria-label="Value Identified" role="note"></div>
										<div class="value-info-popup">
											<div class="arrow-point"></div>
											<span>Value Identified</span>
										</div>
									</div>
								</div>
								<!-- Bet Now button -->
								<div class="scroll-cell bet-col"
									*ngIf="environment.sportExclusiveBookmakers?.['GOLF'] !== 'tab'"
									[class]="bestFuturesOddsBookmaker(player, golfFuturesMarket)"
								>
									<a class="bet-button"
										*ngIf="bestFuturesOddsBookmaker(player, golfFuturesMarket) && bestFuturesOddsBookmaker(player, golfFuturesMarket) !== 'tab'"
										[style.backgroundColor]="bestFuturesOddsBookmaker(player, golfFuturesMarket) | bookBackgroundColour"
										[style.color]="bestFuturesOddsBookmaker(player, golfFuturesMarket) | bookForegroundColour"
										[href]="betService.bookmakerLink(bestFuturesOddsBookmaker(player, golfFuturesMarket))"
										attr.data-recording-click-props='{
											"odds-bookmaker": "{{ bestFuturesOddsBookmaker(player, golfFuturesMarket) }}",
											"odds-path": "{{ document?.location.pathname }}",
											"odds-component": "golf-tournament",
											"odds-sport": "GOLF",
											"odds-futures-market": "winner",
											"odds-option": "{{ player.playerFirstName }} {{ player.playerLastName }}",
											"odds-value": {{ formattedBestFuturesOdds(player, golfFuturesMarket) }}
										}'
										target="_blank"
										attr.data-recording-click-props='{
											"odds-bookmaker": "{{ bestFuturesOddsBookmaker(player, golfFuturesMarket) }}",
											"odds-path": "{{ document?.location.pathname }}",
											"odds-component": "golf-tournament",
											"odds-sport": "GOLF",
											"odds-futures-market": "winner",
											"odds-option": "{{ player.playerFirstName }} {{ player.playerLastName }}",
											"odds-value": {{ formattedBestFuturesOdds(player, golfFuturesMarket) }}
										}'
										rel="noreferrer">
										<img loading="lazy"
											class="bookie-icon-white"
											[src]="bestFuturesOddsBookmaker(player, golfFuturesMarket) | bookIconAlt"
											[alt]="betService.stylisedBookName(bestFuturesOddsBookmaker(player, golfFuturesMarket))"
										>
										<span class="bet-text">{{ localisationService.localeTerm('bet_button_cta', 'title-case') }}</span>
									</a>
								</div>
							</div>
						</div>

					</div>
				</div>
				<div class="load-more-btn" *ngIf="futuresPlayerLimit && eligibleFuturesPlayers.length > futuresPlayerLimit"
					(click)="clearFuturesPlayerLimit()">
					Show More
				</div>
				<div class="load-more-btn" *ngIf="!futuresPlayerLimit"
					(click)="resetFuturesPlayerLimit()">
					Show Less
				</div>
			</div>
		</div>
		<!-- <div class="match-page-tab h2h" *ngIf="tournamentData.H2HData && tournamentActiveTab === 'h2h'">
			<div class="title-row">
				<div class="tab-heading">
					Pre-Tournament H2H Matchups
				</div>
				<div></div>
			</div>
			<div class="h2h-options-row">

				<#-- Player Search Bar --#>
				<div class="player-search">
					<input type="text" [(ngModel)]="playerSearch" placeholder="Search for players..."
						(keyup)="setAllPlayerLists()" />
					<div class="search-clear-button" (click)="clearPlayerSearch()" [class.hidden-button]="playerSearch === ''">
						<fa-icon [icon]="faTimesCircle" aria-label="Clear Search Query" role="button"></fa-icon>
					</div>
					<div class="search-icon-ctr">
						<fa-icon [icon]="faSearch" class="search-icon" aria-hidden="true"></fa-icon>
					</div>
				</div>

				<#-- Bookie Key --#>
				<div class="bookie-key-ctr"
					*ngIf="!(environment.sportExclusiveBookmakers && environment.sportExclusiveBookmakers['GOLF'])"
				>
					<div class="bookie-key single-row compact-only">
						<div class="key-ctr">
							<div class="key-listing">
								<div class="bookie-icon value-icon"></div>
								<div class="bookie-name">Value Identified</div>
							</div>
						</div>
					</div>

					<div class="bookie-key">
						<#-- <div class="key-title">Key</div> --#>
						<div class="key-ctr">
							<div class="key-listing" *ngFor="let option of bookOptions" [class]="option">
								<img loading="lazy"
									class="bookie-icon"
									[src]="option | bookIcon"
									alt=""
								>
								<div class="bookie-name">{{ betService.stylisedBookName(option) }}</div>
							</div>
						</div>
	
					</div>
				</div>

				<div class="bookie-ident"
					*ngIf="environment.sportExclusiveBookmakers && environment.sportExclusiveBookmakers['GOLF'] && !['tab', 'default'].includes(environment.sportExclusiveBookmakers['GOLF'])"
					[class]="environment.sportExclusiveBookmakers && environment.sportExclusiveBookmakers['GOLF']
						? environment.sportExclusiveBookmakers['GOLF'] : ''"
				>
					<div class="powered-by">
						Odds powered by
					</div>
					<img loading="lazy"
						class="bookie-logo"
						[src]="environment.sportExclusiveBookmakers['GOLF'] | bookLogo"
						[alt]="betService.stylisedBookName(environment.sportExclusiveBookmakers['GOLF'])"
					>
				</div>
			</div>
			<div class="h2h-shell">
				<div class="h2h-ctr">
					<div class="h2h-header">
						<div class="header-cell player-col">
							Players
						</div>
						<div class="header-cell prob-col">
							<span class="large-only">Win Probability</span>
							<span class="compact-only">Prob.</span>
						</div>
						<div class="header-cell odds-col">
							{{ (environment.sportExclusiveBookmakers && environment.sportExclusiveBookmakers['GOLF']) ? 'Odds' : 'Best Odds' }}
						</div>
						<div class="header-cell value-col">
							<div class="value-indi">
								<div class="value-icon" aria-label="Value Identified" role="note"></div>
								<div class="value-info-popup">
									<div class="arrow-point"></div>
									<span>Value Identified</span>
								</div>
							</div>
						</div>
						<div class="header-cell bet-col">
						</div>
					</div>
					<div class="h2h-group-list">
						<div class="h2h-group" *ngFor="let pair of displayedH2HPairs">
							<div class="h2h-player-row">
								<div class="player-cell player-col">
									<div class="info-box player-box">
										<app-flag-icon class="team-logo flag"
											[countryCode]="countryLookup[(pair.player1Country | uppercase) || ''] || ''"
										></app-flag-icon>
										{{ pair.player1Name }}
									</div>

								</div>
								<div class="player-cell prob-col">
									<div class="info-box">
										<div class="gradient-fill" [style.opacity]="pair.player1WinProb">

										</div>
										<div class="gradient-overlay">
											{{ ((pair.player1WinProb * 100) | number: '1.0-0') + '%' }}
										</div>
									</div>
								</div>
								<div class="player-cell odds-col">
									<div class="info-box">
										{{ formattedBestH2HOdds(pair, 1) }}
									</div>

								</div>
								<div class="player-cell value-col">
									<div class="value-indi" *ngIf="h2hValueOpacity(pair, 1) > 0"
										[style.opacity]="h2hValueOpacity(pair, 1)">
										<div class="value-icon" aria-label="Value Identified" role="note"></div>
										<div class="value-info-popup">
											<div class="arrow-point"></div>
											<span>Value Identified</span>
										</div>
									</div>
								</div>
								<div class="player-cell bet-col" [class]="bestH2HOddsBookmaker(pair, 1)">
									<a class="bet-button"
										[style.backgroundColor]="bestH2HOddsBookmaker(pair, 1) | bookBackgroundColour"
										[style.color]="bestH2HOddsBookmaker(pair, 1) | bookForegroundColour"
										*ngIf="bestH2HOddsBookmaker(pair, 1)"
										[href]="betService.bookmakerLink(bestH2HOddsBookmaker(pair, 1))"
										target="_blank"
										rel="noreferrer">
										<img loading="lazy"
											class="bookie-icon-white"
											[src]="bestH2HOddsBookmaker(pair, 1) | bookIconAlt"
											[alt]="betService.stylisedBookName(bestH2HOddsBookmaker(pair, 1))"
										>
										<span class="bet-text">{{ localisationService.localeTerm('bet_button_cta', 'title-case') }}</span>
									</a>
								</div>
							</div>
							<div class="h2h-player-row">
								<div class="player-cell player-col">
									<div class="info-box player-box">
										<app-flag-icon class="team-logo flag"
											[countryCode]="countryLookup[(pair.player2Country | uppercase) || ''] || ''"
										></app-flag-icon>
										{{ pair.player2Name }}
									</div>
								</div>
								<div class="player-cell prob-col">
									<div class="info-box">
										<div class="gradient-fill" [style.opacity]="pair.player2WinProb">

										</div>
										<div class="gradient-overlay">
											{{ ((pair.player2WinProb * 100) | number: '1.0-0') + '%' }}
										</div>
									</div>
								</div>
								<div class="player-cell odds-col">
									<div class="info-box">
										{{ formattedBestH2HOdds(pair, 2) }}
									</div>
								</div>
								<div class="player-cell value-col">
									<div class="value-indi" *ngIf="h2hValueOpacity(pair, 2) > 0"
										[style.opacity]="h2hValueOpacity(pair, 2)">
										<div class="value-icon" aria-label="Value Identified" role="note"></div>
										<div class="value-info-popup">
											<div class="arrow-point"></div>
											<span>Value Identified</span>
										</div>
									</div>
								</div>
								<div class="player-cell bet-col" [class]="bestH2HOddsBookmaker(pair, 2)">
									<a class="bet-button"
										[style.backgroundColor]="bestH2HOddsBookmaker(pair, 2) | bookBackgroundColour"
										[style.color]="bestH2HOddsBookmaker(pair, 2) | bookForegroundColour"
										*ngIf="bestH2HOddsBookmaker(pair, 2)"
										[href]="betService.bookmakerLink(bestH2HOddsBookmaker(pair, 2))"
										target="_blank"
										rel="noreferrer">
										<img loading="lazy"
											class="bookie-icon-white"
											[src]="bestH2HOddsBookmaker(pair, 2) | bookIconAlt"
											[alt]="betService.stylisedBookName(bestH2HOddsBookmaker(pair, 2))"
										>
										<span class="bet-text">{{ localisationService.localeTerm('bet_button_cta', 'title-case') }}</span>
									</a>
								</div>
							</div>
							<div class="h2h-player-row">
								<div class="player-cell player-col">
									<div class="info-box player-box">
										<img class="team-logo hidden">
										Tie
									</div>
								</div>
								<div class="player-cell prob-col">
									<div class="info-box">
										<div class="gradient-fill" [style.opacity]="pair.tieProb">

										</div>
										<div class="gradient-overlay">
											{{ ((pair.tieProb * 100) | number: '1.0-0') + '%' }}
										</div>
									</div>
								</div>
								<div class="player-cell odds-col">
								</div>
								<div class="player-cell value-col">
								</div>
								<div class="player-cell bet-col">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="load-more-btn" *ngIf="h2hPairLimit && eligibleH2HPairs.length > h2hPairLimit"
				(click)="clearH2HPairLimit()">
				Show More
			</div>
			<div class="load-more-btn" *ngIf="!h2hPairLimit"
				(click)="resetH2HPairLimit()">
				Show Less
			</div>
		</div> -->
		<!-- <div class="match-page-tab three-ball" *ngIf="tournamentData.ThreeBall && tournamentActiveTab === 'three-ball'">
			<div class="title-row">
				<div class="tab-heading">
					Round 1, 3-Ball Matchups
				</div>
				<div></div>
			</div>
			<div class="three-ball-options-row">
				<#-- Player Search Bar --#>
				<div class="player-search">
					<input type="text" [(ngModel)]="playerSearch" placeholder="Search for players..."
						(keyup)="setAllPlayerLists()" />
					<div class="search-clear-button" (click)="clearPlayerSearch()" [class.hidden-button]="playerSearch === ''">
						<fa-icon [icon]="faTimesCircle" aria-label="Clear Search Query" role="button"></fa-icon>
					</div>
					<div class="search-icon-ctr">
						<fa-icon [icon]="faSearch" class="search-icon" aria-hidden="true"></fa-icon>
					</div>
				</div>
				<#-- Bookie Key --#>
				<div class="bookie-key-ctr"
					*ngIf="!(environment.sportExclusiveBookmakers && environment.sportExclusiveBookmakers['GOLF'])"
				>
					<div class="bookie-key single-row compact-only">
						<div class="key-ctr">
							<div class="key-listing">
								<div class="bookie-icon value-icon"></div>
								<div class="bookie-name">Value Identified</div>
							</div>
						</div>
					</div>

					<div class="bookie-key">
						<#-- <div class="key-title">Key</div> --#>
						<div class="key-ctr">
							<div class="key-listing" *ngFor="let option of bookOptions" [class]="option">
								<img loading="lazy"
									class="bookie-icon"
									[src]="option | bookIcon"
									alt=""
								>
								<div class="bookie-name">{{ betService.stylisedBookName(option) }}</div>
							</div>
						</div>
	
					</div>
				</div>

				<div class="bookie-ident"
					*ngIf="environment.sportExclusiveBookmakers && environment.sportExclusiveBookmakers['GOLF'] && !['tab', 'default'].includes(environment.sportExclusiveBookmakers['GOLF'])"
					[class]="environment.sportExclusiveBookmakers && environment.sportExclusiveBookmakers['GOLF']
						? environment.sportExclusiveBookmakers['GOLF'] : ''"
				>
					<div class="powered-by">
						Odds powered by
					</div>
					<img loading="lazy"
						class="bookie-logo"
						[src]="environment.sportExclusiveBookmakers['GOLF'] | bookLogo"
						[alt]="betService.stylisedBookName(environment.sportExclusiveBookmakers['GOLF'])"
					>
				</div>
			</div>
			<div class="three-ball-shell">
				<div class="three-ball-ctr">
					<div class="three-ball-header">
						<div class="header-cell time-col">
							Tee Time
						</div>
						<div class="header-cell player-col">
							Players
						</div>
						<div class="header-cell prob-col">
							<span class="large-only">Win Probability</span>
							<span class="compact-only">Prob.</span>
						</div>
						<div class="header-cell odds-col">
							{{ (environment.sportExclusiveBookmakers && environment.sportExclusiveBookmakers['GOLF']) ? 'Odds' : 'Best Odds' }}
						</div>
						<div class="header-cell value-col">
							<div class="value-indi">
								<div class="value-icon" aria-label="Value Identified" role="note"></div>
								<div class="value-info-popup">
									<div class="arrow-point"></div>
									<span>Value Identified</span>
								</div>
							</div>
						</div>
						<div class="header-cell bet-col">
						</div>
					</div>
					<div class="three-ball-group-list">
						<div class="three-ball-group" *ngFor="let group of displayed3BallGroups">
							<div class="three-ball-time time-col">
								{{ group.formattedTeeTime }}
							</div>
							<div class="player-ctr">
								<div class="three-ball-player-row">
									<div class="player-cell player-col">
										<div class="info-box player-box">
											<app-flag-icon class="team-logo flag"
												[countryCode]="countryLookup[(group.player1Country | uppercase) || ''] || ''"
											></app-flag-icon>
											{{ group.player1Name }}
										</div>
									</div>
									<div class="player-cell prob-col">
										<div class="info-box">
											<div class="gradient-fill" [style.opacity]="group.player1WinProb">

											</div>
											<div class="gradient-overlay">
												{{ ((group.player1WinProb * 100) | number: '1.0-0') + '%' }}
											</div>
										</div>
									</div>
									<div class="player-cell odds-col">
										<div class="info-box">
											{{ formattedBest3BallOdds(group, 1) }}
										</div>
									</div>
									<div class="player-cell value-col">
										<div class="value-indi" *ngIf="threeBallValueOpacity(group, 1) > 0"
											[style.opacity]="threeBallValueOpacity(group, 1)">
											<div class="value-icon" aria-label="Value Identified" role="note"></div>
											<div class="value-info-popup">
												<div class="arrow-point"></div>
												<span>Value Identified</span>
											</div>
										</div>
									</div>
									<div class="player-cell bet-col" [class]="best3BallOddsBookmaker(group, 1)">
										<a class="bet-button"
											[style.backgroundColor]="best3BallOddsBookmaker(group, 1) | bookBackgroundColour"
											[style.color]="best3BallOddsBookmaker(group, 1) | bookForegroundColour"
											*ngIf="best3BallOddsBookmaker(group, 1)"
											[href]="betService.bookmakerLink(best3BallOddsBookmaker(group, 1))"
											target="_blank"
											rel="noreferrer">
											<img loading="lazy"
												class="bookie-icon-white"
												[src]="best3BallOddsBookmaker(group, 1) | bookIconAlt"
												[alt]="betService.stylisedBookName(best3BallOddsBookmaker(group, 1))"
											>
											<span class="bet-text">{{ localisationService.localeTerm('bet_button_cta', 'title-case') }}</span>
										</a>
									</div>
								</div>
								<div class="three-ball-player-row">
									<div class="player-cell player-col">
										<div class="info-box player-box">
											<app-flag-icon class="team-logo flag"
												[countryCode]="countryLookup[(group.player2Country | uppercase) || ''] || ''"
											></app-flag-icon>
											{{ group.player2Name }}
										</div>
									</div>
									<div class="player-cell prob-col">
										<div class="info-box">
											<div class="gradient-fill" [style.opacity]="group.player2WinProb">

											</div>
											<div class="gradient-overlay">
												{{ ((group.player2WinProb * 100) | number: '1.0-0') + '%' }}
											</div>
										</div>
									</div>
									<div class="player-cell odds-col">
										<div class="info-box">
											{{ formattedBest3BallOdds(group, 2) }}
										</div>
									</div>
									<div class="player-cell value-col">
										<div class="value-indi" *ngIf="threeBallValueOpacity(group, 2) > 0"
											[style.opacity]="threeBallValueOpacity(group, 2)">
											<div class="value-icon" aria-label="Value Identified" role="note"></div>
											<div class="value-info-popup">
												<div class="arrow-point"></div>
												<span>Value Identified</span>
											</div>
										</div>
									</div>
									<div class="player-cell bet-col" [class]="best3BallOddsBookmaker(group, 2)">
										<a class="bet-button"
											[style.backgroundColor]="best3BallOddsBookmaker(group, 2) | bookBackgroundColour"
											[style.color]="best3BallOddsBookmaker(group, 2) | bookForegroundColour"
											*ngIf="best3BallOddsBookmaker(group, 2)"
											[href]="betService.bookmakerLink(best3BallOddsBookmaker(group, 2))"
											target="_blank"
											rel="noreferrer">
											<img loading="lazy"
												class="bookie-icon-white"
												[src]="best3BallOddsBookmaker(group, 2) | bookIconAlt"
												[alt]="betService.stylisedBookName(best3BallOddsBookmaker(group, 2))"
											>
											<span class="bet-text">{{ localisationService.localeTerm('bet_button_cta', 'title-case') }}</span>
										</a>
									</div>
								</div>
								<div class="three-ball-player-row">
									<div class="player-cell player-col">
										<div class="info-box player-box">
											<app-flag-icon class="team-logo flag"
												[countryCode]="countryLookup[(group.player3Country | uppercase) || ''] || ''"
											></app-flag-icon>
											{{ group.player3Name }}
										</div>
									</div>
									<div class="player-cell prob-col">
										<div class="info-box">
											<div class="gradient-fill" [style.opacity]="group.player3WinProb">

											</div>
											<div class="gradient-overlay">
												{{ ((group.player3WinProb * 100) | number: '1.0-0') + '%' }}
											</div>
										</div>
									</div>
									<div class="player-cell odds-col">
										<div class="info-box">
											{{ formattedBest3BallOdds(group, 3) }}
										</div>
									</div>
									<div class="player-cell value-col">
										<div class="value-indi" *ngIf="threeBallValueOpacity(group, 3) > 0"
											[style.opacity]="threeBallValueOpacity(group, 3)">
											<div class="value-icon" aria-label="Value Identified" role="note"></div>
											<div class="value-info-popup">
												<div class="arrow-point"></div>
												<span>Value Identified</span>
											</div>
										</div>
									</div>
									<div class="player-cell bet-col" [class]="best3BallOddsBookmaker(group, 3)">
										<a class="bet-button"
											[style.backgroundColor]="best3BallOddsBookmaker(group, 3) | bookBackgroundColour"
											[style.color]="best3BallOddsBookmaker(group, 3) | bookForegroundColour"
											*ngIf="best3BallOddsBookmaker(group, 3)"
											[href]="betService.bookmakerLink(best3BallOddsBookmaker(group, 3))"
											target="_blank"
											rel="noreferrer">
											<img loading="lazy"
												class="bookie-icon-white"
												[src]="best3BallOddsBookmaker(group, 3) | bookIconAlt"
												[alt]="betService.stylisedBookName(best3BallOddsBookmaker(group, 3))"
											>
											<span class="bet-text">{{ localisationService.localeTerm('bet_button_cta', 'title-case') }}</span>
										</a>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>
			<div class="load-more-btn" *ngIf="threeBallGroupLimit && eligible3BallGroups.length > threeBallGroupLimit"
				(click)="clearThreeBallGroupLimit()">
				Show More
			</div>
			<div class="load-more-btn" *ngIf="!threeBallGroupLimit"
				(click)="resetThreeBallGroupLimit()">
				Show Less
			</div>
		</div> -->
	</div>
</div>